
export default {
    getDprSignatures: (state) => state.dprSignatures,
}